<template lang="html">

  <section class="login" v-if="!hideForm">
    <h1>Log In</h1>
    <div class="user-note">
      You must complete your inspection report within 7 days of your move-in. Only one roommate per unit may complete the inspection.
    </div>
    <div class="form-item">
      <select name="property" v-model="property" v-on:change="getUnits" :disabled="!propertiesReady">
        <option value="">Select your Property</option>
        <option v-for="prop in propertyNamesSorted" :key="propertiesByName[prop]" :value="propertiesByName[prop]">{{ prop }}</option>
      </select>
    </div>
    <div class="form-item">
      <select name="unit" v-model="unit" :disabled="!unitsReady">
        <option value="">{{ unitPlaceholder }}</option>
        <option v-for="unit in unitNamesSorted" :key="unitsByName[unit]" :value="unitsByName[unit]">{{ unit }}</option>
      </select>
    </div>
    <div class="form-item"><input v-model="lastName" name="lastName" placeholder="LAST NAME"></div>
    <div class="form-item"><input v-model="lastFourOfPhone" inputmode="numeric" pattern="\d*" maxlength="4" name="lastFourOfPhone" placeholder="LAST 4 DIGITS OF PHONE"></div>

    <div><button v-on:click="login" :disabled="needsMoreUserInput">Login</button></div>

  </section>

</template>

<script lang="js">

  import router from '@/router.js';

  export default  {
    name: 'login',
    props: [],
    mounted() {

    },
    data() {
      return {
        propertiesReady : false,
        unitsReady : false,
        units : {},
        property : '',
        unit : '',
        lastName : '',
        lastFourOfPhone : '',
        hideForm : false,
        propertyPlaceholder : 'Loading properties',
        unitPlaceholder : '',
      }
    },
    computed: {
      needsMoreUserInput: function () {
        return this.property.length < 1 || this.unit.length < 1 || this.lastName.length < 1 || this.lastFourOfPhone.length < 1;
      },
      properties : function (){
        if( Object.keys( this.$store.state.properties ).length > 0 ){
          this.propertiesReady = true;
          this.propertyPlaceholder = 'Select your property';
        }
        return this.$store.state.properties;
      },
      propertiesByName : function(){
        let ids = Object.keys(this.properties);
        let names = {};
        for( let id of ids ){
          if( this.properties[ id ].hasOwnProperty('Name') ){
            names[ this.properties[ id ].Name ] = id;
          }
        }
        return  names;
      },
      propertyNamesSorted : function(){
        return Object.keys( this.propertiesByName ).sort();
      },
      unitsByName : function(){
        let ids = Object.keys(this.units);
        let names = {};
        if( ids.length > 0 ){
          for( let id of ids ){
            if( this.units[ id ].hasOwnProperty('Name') ){
              names[ this.units[ id ].Name ] = id;
            }
          }
        }
        return  names;
      },
      unitName : function(){
        return this.units[ this.unit ].Name;
      },
      unitNamesSorted : function(){
        return Object.keys( this.unitsByName ).sort();
      },
    },
    methods: {
      login(){
        this.hideForm = true;
        let credentials = {
          property : this.property,
          unit : this.unit,
          unitName : this.unitName,
          lastName : this.lastName,
          lastFourOfPhone : this.lastFourOfPhone
        };
        this.$store.dispatch('login', credentials).then( () => {
          this.$store.dispatch( 'postMessage', { msg : 'Successfully loaded your inspection!', timeout : 3000, allowClose : true });
          router.push('/');
        }).then( () => {
          console.log("running checkallcompleted");
          this.$store.dispatch( 'checkAllCompleted' );
        }).catch( reason => {
            this.$store.dispatch( 'postMessage', { msg : "Could not log in. Please try again.", timeout : 15000, allowClose : true });
            console.log( reason );
            this.hideForm = false;
        });

      },
      getUnits(){
        if( this.property == '' ){
          return;
        }
        //commit fetch units message with value of this.property
        this.unitsReady = false;
        this.units = {};
        this.unit = '';
        this.unitPlaceholder = 'Loading units...';
        this.$store.dispatch( 'fetchPropertyUnits', this.property ).then(() => {
          this.unitsReady = true;
          this.updateUnits();
        });

      },
      updateUnits(){
        let fullProperty = this.$store.getters.property( this.property );
        if( fullProperty.hasOwnProperty( 'units' ) ){
          this.units = fullProperty.units;
          this.unitsReady = true;
          this.unitPlaceholder = 'Select your unit';
        }
      }
    }
}
</script>

<style scoped lang="scss">
  .login {

  }
</style>
